import React from 'react'

import { getMutedBackgroundFromIndicatorColor } from '../status-badge/hex-tint'
import './Badge.css'

export interface BadgeProps {
  color: string
  label: string
  icon?: React.ReactNode
}

export function Badge({ color, label, icon }: BadgeProps): React.ReactElement {
  const backgroundColor = getMutedBackgroundFromIndicatorColor(color)

  return (
    <span className="badge" style={{ backgroundColor, color }}>
      {icon && (
        <span className="badge__icon" aria-hidden>
          {icon}
        </span>
      )}
      <span className="badge__label">{label}</span>
    </span>
  )
}
